import React from "react";
import styled from "styled-components";
import title from "../img/title-booth.svg";
import device from "../helpers/device";
import nl2br from "react-nl2br";

export default function({ store, ...props }) {
  const { booth } = store;

  return (
    <Root {...props}>
      <Title>
        <img src={title} alt="BOOTH" width="84" />
      </Title>
      <Contents>
        {booth.map(({ id, title, text }) => (
          <dl key={id}>
            <dt>{nl2br(title)}</dt>
            <dd>{nl2br(text)}</dd>
          </dl>
        ))}
      </Contents>
    </Root>
  );
}

const Root = styled.div`
  background: #f2f2f2;
  margin: 15px auto 0 auto;
  width: calc(100% - 40px);
  @media ${device.mobileL} {
    width: 840px;
    margin: 40px auto 0 auto;
  }
`;

const Title = styled.h3`
  padding: 20px;
  padding-bottom: 0;
  @media ${device.mobileL} {
    padding: 30px;
    padding-bottom: 0;
    display: grid;
    grid-template-columns: 33.333% 1fr 1fr;
  }
`;

const Contents = styled.div`
  padding: 15px;
  padding-top: 0;
  @media ${device.mobileL} {
    padding: 15px;
    display: grid;
    grid-template-columns: 33.333% 1fr 1fr;
  }
  dl {
    margin-top: 20px;
    @media ${device.mobileL} {
      margin-top: 0px;
    }
  }
  dt {
    font-weight: bold;
    margin-bottom: 10px;
  }
  @media ${device.mobileL} {
    dl {
      padding: 10px 15px;
    }
    dt {
      font-weight: bold;
      margin-bottom: 5px;
    }
  }
`;
